import { render } from "./Success.vue?vue&type=template&id=1d53d97d&scoped=true"
import script from "./Success.vue?vue&type=script&lang=js"
export * from "./Success.vue?vue&type=script&lang=js"

import "./Success.vue?vue&type=style&index=0&id=1d53d97d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d53d97d"],['__file',"src/views/public/newAccount/Success.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d53d97d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d53d97d', __exports__)) {
    api.reload('1d53d97d', __exports__)
  }
  
  module.hot.accept("./Success.vue?vue&type=template&id=1d53d97d&scoped=true", () => {
    api.rerender('1d53d97d', render)
  })

}


export default __exports__